module.exports = __webpack_public_path__ + "static/media/youtube_us.2b2baa1a.png";